import {api} from '../../../shared';
import {ProjectModel, BalanceAdjustmentsWithMetaModel, BalanceAdjustmentsFilter, DepositFundsDTO} from '../model';

export const projectApi = {
  getProject: async (): Promise<ProjectModel> => {
    const {data} = await api.get<ProjectModel>('/api/finance/admin/project');
    return data;
  },

  getBalanceAdjustments: async (params: BalanceAdjustmentsFilter = {}): Promise<BalanceAdjustmentsWithMetaModel> => {
    const {data} = await api.get<BalanceAdjustmentsWithMetaModel>('/api/finance/admin/project/balance-adjustments', {
      params,
    });
    return data;
  },

  depositFunds: async (depositData: DepositFundsDTO): Promise<void> => {
    await api.post<void>('/api/finance/admin/project/transfers/deposit', depositData);
  },
};
